// import React, { useEffect, useRef, useState } from "react";
// import { Api_Url } from "../../../config/config";
// import axios from "axios";
// import { ErrorToast, SuccessToast } from "../../ToastComponent";

// export const ResidenceModalAdd = ({ResidenceDataFetchFunc}) => {

//   // const [tableData, setTableData] = useState(initialTableData)

//   const fileInputRef = useRef(null);

//   const AllFileLoginData = async () => {
//     try {
//       const id = JSON.parse(sessionStorage.getItem('user'))?.id
//       console.log("id", id)
//       const response = await axios.get(`${Api_Url}api/v1/FileLogin/${id}`, {
//         headers: {
//           Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
//         }
//       })
//       console.log("response", response)
//     } catch (error) {
//       return error
//     }
//   }

//   useEffect(() => {
//     AllFileLoginData()
//   }, [])

//   const [LocalFormData, setLocalFormData] = useState({

//     BranchId: Number,
//     Name: "",
//     Mobile: "",
//     ApplicationNo: "",
//     ResidenceAddress:"",
//     Ownership:Number,
//     IsPurposeMet:false,
//     Selfie:null,
//     Latitude: "",
//     Longitude: "",
//     FamilyMembers:Number,
//     StayingSince:Number
//   });

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     setLocalFormData({ ...LocalFormData, Selfie: file });
//   };

//   const handleDateChange = (date) => {
//     setLocalFormData({ ...LocalFormData, VisitDate: date });
//   };

//   useEffect(() => {
//     if ("geolocation" in navigator) {
//       navigator.geolocation.getCurrentPosition(function (position) {

//         const { latitude, longitude } = position.coords;
//         setLocalFormData({ ...LocalFormData, Latitude: latitude, Longitude: longitude });
//       });
//     } else {
//       console.log("Geolocation is not supported by this browser.");
//     }
//   }, [])

//   const HandleSubmit = async() => {

//     const formData = new FormData();
//     formData.append("BranchId", LocalFormData.BranchId);
//     formData.append("Name", LocalFormData.Name);
//     formData.append("Mobile", LocalFormData.Mobile);
//     formData.append("IsPurposeMet", LocalFormData.IsPurposeMet);
//     formData.append("ApplicationNo", LocalFormData.ApplicationNo);
//     formData.append("ResidenceAddress", LocalFormData.ResidenceAddress);
//     formData.append("Ownership", LocalFormData.Ownership);
//     formData.append("Selfie", LocalFormData.Selfie);
//     formData.append("Latitude", LocalFormData.Latitude);
//     formData.append("Longitude", LocalFormData.Longitude);
//     formData.append("FamilyMembers", LocalFormData.FamilyMembers);
//     formData.append("StayingSince", LocalFormData.StayingSince);

//     if (LocalFormData.Mobile.length !== 10) {
//       ErrorToast("Mobile Number must be exactly 10 digits.");
//       return;
//     };
//     // console.log(LocalFormData)
//     try {
//       const response = await axios.post(`${Api_Url}api/v1/ResidencePd`,formData,{
//         headers: {
//           Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
//           "Content-Type": "multipart/form-data",
//         }
//       })
//       console.log(response)
//       ResidenceDataFetchFunc()
//       resetForm()
//       SuccessToast("ResidencePd Submitted Successfully")
//     } catch (error) {
//       return error.message;
//     }
//   }

//   const resetForm = () => {
//     setLocalFormData({
//       BranchId: Number,
//       Name: "",
//       Mobile: "",
//       ApplicationNo: "",
//       ResidenceAddress:"",
//       Ownership:Number,
//       IsPurposeMet:false,
//       Selfie:null,
//       FamilyMembers:Number,
//       StayingSince:Number
//     });
//     if (fileInputRef.current) {
//       fileInputRef.current.value = "";
//     }
//   };

// const [allbranch,setAllBranch ] = useState('')

// const handle = async() => {
//   try {
//     const response = await axios.get(`${Api_Url}api/v1/Branch?PageNumber=1&PageSize=1000`,{
//       headers: {
//         Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
//       }
//     })
//   console.log(response.data.data)
//   setAllBranch(response.data.data)
//   } catch (error) {
//     return
//   }
// }
// useEffect(()=>{
//   handle()
// },[])

// const validateMobileNumber = (number) => {
//   const regex = /^[0-9]{0,10}$/;
//   return regex.test(number);
// };

// const handleMobileChange = (e) => {
//   const value = e.target.value;
//   if (validateMobileNumber(value)) {
//     setLocalFormData({
//       ...LocalFormData,
//       Mobile: value,
//     });
//   }}

//   return (
//     <>
//       <div id="add_client" className="modal custom-modal fade" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false">
//         <div
//           className="modal-dialog modal-dialog-centered modal-lg"
//           role="document"
//         >
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title">Residence PD</h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//               >
//                 <span aria-hidden="true">×</span>
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="profile-image text-center mt-4 mb-4">
//                 <img
//                   // src={{Applogo} ? {Applogo} : {profileLogo}}
//                   src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTYP-KKtRJXm9qK7k2_PA1utxbxWdpzGIdulQ&s'
//                   alt='mohit'
//                   className="img-fluid rounded-circle"
//                   style={{ width: '100px', height: '100px' }}
//                 />
//               </div>

//               <form>
//                 <div className="row">
//                 <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Branch <span className="text-danger">*</span>
//                       </label>
//                       <select
//                         className="form-control"
//                         value={LocalFormData.BranchId}
//                         onChange={(e) => setLocalFormData({ ...LocalFormData, BranchId: e.target.value })}
//                       >
//                         <option value="">Select Branch</option>
//                         {allbranch && allbranch.length>0 && allbranch.map((res)=>(
//                         <option value={res.id}>{res.name}</option>
//                        ))}
//                         {/* Add more branches as needed */}
//                       </select>
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Customer Name <span className="text-danger">*</span></label>
//                       <input className="form-control" type="text" value={LocalFormData.Name} onChange={(e) => setLocalFormData({ ...LocalFormData, Name: e.target.value })} />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Mobile Number <span className="text-danger">*</span></label>
//                       <input className="form-control" type="text" value={LocalFormData.Mobile} onChange={handleMobileChange} />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Application Number<span className="text-danger">*</span></label>
//                       <input className="form-control" type="text" value={LocalFormData.ApplicationNo} onChange={(e) => setLocalFormData({ ...LocalFormData, ApplicationNo: e.target.value })} />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Residence Address <span className="text-danger">*</span></label>
//                       <input className="form-control" type="text" value={LocalFormData.ResidenceAddress} onChange={(e) => setLocalFormData({ ...LocalFormData, ResidenceAddress: e.target.value })} />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         OwnerShip <span className="text-danger">*</span>
//                       </label>
//                       <select
//                         className="form-control"
//                         value={LocalFormData.Ownership}
//                         onChange={(e) => setLocalFormData({ ...LocalFormData, Ownership: e.target.value })}
//                       >
//                         <option value="">Select OwnerShip</option>
//                         <option value="1">Rented</option>
//                         <option value="2">Self</option>
//                         <option value="3">Parental</option>
//                         {/* Add more branches as needed */}
//                       </select>
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         staying Since<span className="text-danger">*</span>
//                       </label>
//                       <select
//                         className="form-control"
//                         value={LocalFormData.StayingSince}
//                         onChange={(e) => setLocalFormData({ ...LocalFormData, StayingSince: e.target.value })}
//                       >
//                         <option value="">Choose Staying</option>
//                         <option value="1">Less Than One Year</option>
//                         <option value="2">1-3 years</option>
//                         <option value="3">3+ year</option>
//                         {/* Add more branches as needed */}
//                       </select>
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Family Members <span className="text-danger">*</span></label>
//                       <input className="form-control" type="text" value={LocalFormData.FamilyMembers} onChange={(e) => setLocalFormData({ ...LocalFormData, FamilyMembers: e.target.value })} />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <label className="col-form-label">Upload Document <span className="text-danger">*</span></label>
//                     <input
//                       className="form-control"
//                       type="file"
//                       accept="image/*"
//                       ref={fileInputRef}
//                       // value={LocalFormData.Selfie}
//                       onChange={handleFileChange}
//                     />
//                   </div>
//                   <div className="col-md-12">
//                     <label className="col-form-label">
//                       Purpose Met <span className="text-danger">*</span>
//                     </label>
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="flexRadioDefault"
//                         id="flexRadioDefault1"
//                         value="true"
//                         checked={LocalFormData.IsPurposeMet === true}
//                         onChange={(e) => setLocalFormData({ ...LocalFormData, IsPurposeMet: e.target.value === "true" })}
//                       />
//                       <label className="form-check-label" htmlFor="flexRadioDefault1">
//                         Yes
//                       </label>
//                     </div>
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="flexRadioDefault"
//                         id="flexRadioDefault2"
//                         value="false"
//                         checked={LocalFormData.IsPurposeMet === false}
//                         onChange={(e) => setLocalFormData({ ...LocalFormData, IsPurposeMet: e.target.value === "true" })}
//                       />
//                       <label className="form-check-label" htmlFor="flexRadioDefault2">
//                         No
//                       </label>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="submit-section">
//                   <button
//                     className="btn btn-primary submit-btn"
//                     data-bs-dismiss="modal"
//                     aria-label="Close"
//                     type="button"
//                     onClick={HandleSubmit}
//                   >
//                     Submit
//                   </button>
//                 </div>
//               </form>

//             </div>
//           </div>
//         </div>
//       </div>

//     </>
//   );
// };

//Modal

import React, { useEffect, useRef, useState } from "react";
import { Api_Url } from "../../../config/config";
import axios from "axios";
import { ErrorToast, SuccessToast } from "../../ToastComponent";
import { Modal } from "antd";
import { AllFormsUpperphoto } from "../../../Routes/ImagePath";

export const ResidenceModalAdd = ({ ResidenceDataFetchFunc, onClose }) => {
  const fileInputRef = useRef(null);

  const AllFileLoginData = async () => {
    try {
      const id = JSON.parse(sessionStorage.getItem("user"))?.id;
      const response = await axios.get(`${Api_Url}api/v1/FileLogin/${id}`, {
        headers: {
          Authorization: `Bearer ${
            JSON.parse(sessionStorage.getItem("user")).accessToken
          }`,
        },
      });
      console.log("response", response);
    } catch (error) {
      return error;
    }
  };

  useEffect(() => {
    AllFileLoginData();
  }, []);

  const [loading, setLoading] = useState(false);
  const [LocalFormData, setLocalFormData] = useState({
    BranchId: "",
    Name: "",
    Mobile: "",
    ApplicationNo: "",
    ResidenceAddress: "",
    Ownership: "",
    IsPurposeMet: false,
    Selfie: null,
    Latitude: "",
    Longitude: "",
    FamilyMembers: "",
    StayingSince: "",
  });

  const [allbranch, setAllBranch] = useState([]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setLocalFormData({ ...LocalFormData, Selfie: file });
  };

  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        const { latitude, longitude } = position.coords;
        setLocalFormData({
          ...LocalFormData,
          Latitude: latitude,
          Longitude: longitude,
        });
      });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  }, []);
 const validateForm = () => {
    let valid = true;
    if (LocalFormData.BranchId === "") {
      ErrorToast("Branch is required.");
      valid = false;
    }
    if (LocalFormData.Name === "") {
      ErrorToast("Customer Name is required.");
      valid = false;
    }
    if (LocalFormData.Mobile.length !== 10) {
      ErrorToast("Mobile Number must be exactly 10 digits.");
      valid = false;
    }
    if (LocalFormData.ApplicationNo === "") {
      ErrorToast("Application Number is required.");
      valid = false;
    }
    if (LocalFormData.ResidenceAddress === "") {
      ErrorToast("Residence Address is required.");
      valid = false;
    }
    if (LocalFormData.Ownership === "") {
      ErrorToast("Ownership is required.");
      valid = false;
    }
    if (LocalFormData.StayingSince === "") {
      ErrorToast("Staying Since is required.");
      valid = false;
    }
    if (LocalFormData.FamilyMembers === "" || isNaN(LocalFormData.FamilyMembers)) {
      ErrorToast("Family Members must be a number.");
      valid = false;
    }
    if (!LocalFormData.Selfie) {
      ErrorToast("Upload Document is required.");
      valid = false;
    }

    return valid;
  };

  const HandleSubmit = async () => {
    setLoading(true);
    if (!validateForm()) {
      setLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append("BranchId", LocalFormData.BranchId);
    formData.append("Name", LocalFormData.Name);
    formData.append("Mobile", LocalFormData.Mobile);
    formData.append("IsPurposeMet", LocalFormData.IsPurposeMet);
    formData.append("ApplicationNo", LocalFormData.ApplicationNo);
    formData.append("ResidenceAddress", LocalFormData.ResidenceAddress);
    formData.append("Ownership", LocalFormData.Ownership);
    formData.append("Selfie", LocalFormData.Selfie);
    formData.append("Latitude", LocalFormData.Latitude);
    formData.append("Longitude", LocalFormData.Longitude);
    formData.append("FamilyMembers", LocalFormData.FamilyMembers);
    formData.append("StayingSince", LocalFormData.StayingSince);

    try {
      const response = await axios.post(
        `${Api_Url}api/v1/ResidencePd`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log(response);
      ResidenceDataFetchFunc();
      resetForm();
      SuccessToast("ResidencePd Submitted Successfully");
      onClose();
    } catch (error) {
      ErrorToast("An Error Occurred while Submitting.");
      return error.message;
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setLocalFormData({
      BranchId: "",
      Name: "",
      Mobile: "",
      ApplicationNo: "",
      ResidenceAddress: "",
      Ownership: "",
      IsPurposeMet: false,
      Selfie: null,
      Latitude: "",
      Longitude: "",
      FamilyMembers: "",
      StayingSince: "",
    });
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handle = async () => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/Branch?PageNumber=1&PageSize=1000`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      console.log(response.data.data);
      setAllBranch(response.data.data);
    } catch (error) {
      return;
    }
  };
  
  useEffect(() => {
    handle();
  }, []);

  const validateMobileNumber = (number) => {
  const regex = /^[0-9]{0,10}$/;
  return regex.test(number);
};

const handleMobileChange = (e) => {
  const value = e.target.value;
  if (validateMobileNumber(value)) {
    setLocalFormData({
      ...LocalFormData,
      Mobile: value,
    });
  }}

  return (
    <>
      <Modal
        title={<h4>Residence Pd</h4>}
        open={true}
        onOk={onClose}
        onCancel={onClose}
        footer={[
          <div
            className="d-flex justify-content-between align-items-center"
            key="footer"
          >
            <button className="btn btn-danger submit-btn" onClick={onClose}>
              Cancel
            </button>
            <button
              className="btn btn-primary submit-btn"
              onClick={HandleSubmit}
              disabled={loading}
            >
              {loading ? "Submitting..." : "Submit"}
            </button>
          </div>,
        ]}
        width={600}
        maskClosable={false}
        closeIcon={<span style={{ color: "red" }}>X</span>}
      >
        <div className="modal-body mt-5">
          <div className="profile-image text-center mt-4 mb-4">
            <img
              src={AllFormsUpperphoto}
              alt="Profile"
              className="img-fluid rounded-circle"
              style={{ width: "100px", height: "100px" }}
            />
          </div>
          <form>
            <div className="row">
              <div className="col-md-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Branch <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    value={LocalFormData.BranchId}
                    onChange={(e) =>
                      setLocalFormData({
                        ...LocalFormData,
                        BranchId: e.target.value,
                      })
                    }
                  >
                    <option value="">Select Branch</option>
                    {allbranch &&
                      allbranch.length > 0 &&
                      allbranch.map((res) => (
                        <option key={res.id} value={res.id}>{res.name}</option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Customer Name <span className="text-danger">*</span>
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    value={LocalFormData.Name}
                    onChange={(e) =>
                      setLocalFormData({
                        ...LocalFormData,
                        Name: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Mobile Number <span className="text-danger">*</span>
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    value={LocalFormData.Mobile}
                    onChange={handleMobileChange}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Application Number<span className="text-danger">*</span>
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    value={LocalFormData.ApplicationNo}
                    onChange={(e) =>
                      setLocalFormData({
                        ...LocalFormData,
                        ApplicationNo: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Residence Address <span className="text-danger">*</span>
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    value={LocalFormData.ResidenceAddress}
                    onChange={(e) =>
                      setLocalFormData({
                        ...LocalFormData,
                        ResidenceAddress: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Ownership <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    value={LocalFormData.Ownership}
                    onChange={(e) =>
                      setLocalFormData({
                        ...LocalFormData,
                        Ownership: e.target.value,
                      })
                    }
                  >
                    <option value="">Select Ownership</option>
                    <option value="1">Rented</option>
                    <option value="2">Self</option>
                    <option value="3">Parental</option>
                  </select>
                </div>
              </div>
              <div className="col-md-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Staying Since <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    value={LocalFormData.StayingSince}
                    onChange={(e) =>
                      setLocalFormData({
                        ...LocalFormData,
                        StayingSince: e.target.value,
                      })
                    }
                  >
                    <option value="">Choose Staying</option>
                    <option value="1">Less Than One Year</option>
                    <option value="2">1-3 years</option>
                    <option value="3">3+ years</option>
                  </select>
                </div>
              </div>
              <div className="col-md-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Family Members <span className="text-danger">*</span>
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    value={LocalFormData.FamilyMembers}
                    onChange={(e) =>
                      setLocalFormData({
                        ...LocalFormData,
                        FamilyMembers: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="col-md-6">
                <label className="col-form-label">
                  Upload Document <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="file"
                  accept="image/*"
                  ref={fileInputRef}
                  onChange={handleFileChange}
                />
              </div>
              <div className="col-md-12">
                <label className="col-form-label">
                  Purpose Met <span className="text-danger">*</span>
                </label>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="flexRadioDefault"
                    id="flexRadioDefault1"
                    value="true"
                    checked={LocalFormData.IsPurposeMet === true}
                    onChange={(e) =>
                      setLocalFormData({
                        ...LocalFormData,
                        IsPurposeMet: e.target.value === "true",
                      })
                    }
                  />
                  <label className="form-check-label" htmlFor="flexRadioDefault1">
                    Yes
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="flexRadioDefault"
                    id="flexRadioDefault2"
                    value="false"
                    checked={LocalFormData.IsPurposeMet === false}
                    onChange={(e) =>
                      setLocalFormData({
                        ...LocalFormData,
                        IsPurposeMet: e.target.value === "true",
                      })
                    }
                  />
                  <label className="form-check-label" htmlFor="flexRadioDefault2">
                    No
                  </label>
                </div>
              </div>
            </div>
          </form>
        </div>
      </Modal>
    </>
  );
};
